// extracted by mini-css-extract-plugin
export default {"AccountModal":"AccountModal-module__AccountModal__ozJMr","ModalSelect":"AccountModal-module__ModalSelect__MR5rC"};